/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleDiscountRequest } from '../../models/article-discount-request';

export interface UpdateArticleDiscount$Params {
  id: number;
  articleId: number;
  index: number;
      body: ArticleDiscountRequest
}

export function updateArticleDiscount(http: HttpClient, rootUrl: string, params: UpdateArticleDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateArticleDiscount.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('articleId', params.articleId, {});
    rb.path('index', params.index, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateArticleDiscount.PATH = '/offers/{id}/articles/{articleId}/discounts/{index}';
